import { LoadingContainer } from 'components/loadingContainer'
import { DownloadTickets } from 'features/user/Ticket'
import { useEventById } from 'hooks/admin/useEvents'
import { useParams } from 'react-router-dom'

export const DownloadTicketsPage = () => {
    const { eventId } = useParams()
    const { data: currentEvent, isLoading, error } = useEventById(eventId || '')

    return (
        <LoadingContainer isLoading={isLoading} error={error}>
            <meta name="robots" content="noindex, nofollow" />
            {currentEvent && <DownloadTickets currentEvent={currentEvent} />}
        </LoadingContainer>
    )
}
